var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPorM2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "72px",
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadora-01flujo2",
    transform: "translate(-718.000000, -477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(618.000000, 450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(101.500000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    stroke: "#0072CE",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,10 L59,10 C59.5522847,10 60,10.4477153 60,11 L60,59 C60,59.5522847 59.5522847,60 59,60 L11,60 C10.4477153,60 10,59.5522847 10,59 L10,11 C10,10.4477153 10.4477153,10 11,10 Z",
    id: "Rectangle",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(59.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -1.38777878e-16,
    x2: 0.5,
    y2: 10,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 5,
    x2: 5.5,
    y2: 15,
    id: "Line-2-Copy",
    transform: "translate(5.500000, 10.000000) rotate(-90.000000) translate(-5.500000, -10.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(59.500000, 59.500000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 0.5,
    y2: 10.5,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: -4.5,
    x2: 5.5,
    y2: 5.5,
    id: "Line-2-Copy",
    transform: "translate(5.500000, 0.500000) rotate(-90.000000) translate(-5.500000, -0.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(0.000000, 59.500000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0.5,
    x2: 10,
    y2: 10.5,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -4.5,
    x2: 5,
    y2: 5.5,
    id: "Line-2-Copy",
    transform: "translate(5.000000, 0.500000) rotate(-90.000000) translate(-5.000000, -0.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: -1.38777878e-16,
    x2: 10,
    y2: 10,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4,
    x2: 5,
    y2: 14,
    id: "Line-2-Copy",
    transform: "translate(5.000000, 9.000000) rotate(-90.000000) translate(-5.000000, -9.000000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(20.000000, 20.000000)",
    fill: "#0072CE",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 20,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    id: "m\\xB2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.13,
    y: 23
  }, "m\xB2")))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPorM2);
export default __webpack_public_path__ + "static/media/ico-por-m2.dd7f9f92.svg";
export { ForwardRef as ReactComponent };